import React from "react";
import {observer} from "mobx-react";
import {
    StandardDialogContentComponent
} from "../../../../../components/modal/content/standard-dialog-content.component";
import {StandardDialogPageComponent} from "../../../../../components/modal/page/standard-dialog-page.component";
import {StandardDialogHeaderComponent} from "../../../../../components/modal/header/standard-dialog-header.component";
import {IDialogConfirmationHandler} from "../../../../../services/dialog/dialog.service.interface";
import styled from "styled-components";
import {RandomSeatsGridComponent} from "./random-seats-grid.component";
import {useServices} from "../../../../../hooks/use-services.hook";
import {SeatSelectionReasonComponent} from "./seat-selection-reason.component";
import {HandWithCashIcon} from "../../../../../assets/svg/hand-with-cash.icon";
import {ScareFaceIcon} from "../../../../../assets/svg/scare-face.icon";
import {
    UpsellSuggestionComponent
} from "../../../../../components/upsell-suggestion-button/upsell-suggestion.component";
import {
    ISegmentSeatMapEditorViewModel
} from "../../../../../services/booking/models/seat-maps/segment-seat-map-editor-view-model.interface";
import {ShootingStarIcon} from "../../../../../assets/svg/shooting-star.icon";
import {HIGHLIGHTED_SEATS_Z_INDEX} from "./random-seat-alocation-css-consts";


const DialogContentRoot = styled(StandardDialogContentComponent)`
    --padding-start: 0;
    --padding-end: 0;
    --padding-top: 0;
    --padding-bottom: 0;
    &::part(scroll) {
        overflow: hidden;
    }
    
`

const DialogContentContainerBox = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    padding: 0 ${props => props.theme.spacing.dialogHorizontalPadding};
    gap: ${props => props.theme.spacing.spacing16};
`


const AircraftBodyPartBox = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    background-image: url('data:image/svg+xml;utf8,%3Csvg%20width%3D%22596%22%20height%3D%22323%22%20viewBox%3D%220%200%20596%20323%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Cpath%20fill-rule%3D%22evenodd%22%20clip-rule%3D%22evenodd%22%20d%3D%22M405.256%20-543.941C405.256%20-543.941%20336.698%20-681.841%20284.27%20-681.841C231.843%20-681.841%20163.285%20-543.941%20163.285%20-543.941H163.298C141.817%20-517.099%20143.136%20-464.163%20143.136%20-464.163V-3.05243L140.927%200.723938C140.927%209.6994%20136.525%2037.4703%20123.439%2053.8887C117.667%2061.1322%20106.915%2065.6169%20106.915%2065.6169L18.4686%20110.41L-95.8268%20168.302C-95.8268%20168.302%20-555.691%20401.294%20-569.324%20408.448C-596.032%20422.463%20-631.262%20449.496%20-641.35%20476.469C-649.87%20499.25%20-650.278%20511.996%20-650.922%20532.128C-651.04%20535.826%20-651.167%20539.785%20-651.354%20544.098V567.554C-646.018%20552.965%20-634.067%20522.284%20-628.946%20516.349C-622.543%20508.913%20-613.74%20502.273%20-580.929%20492.5C-567.095%20488.379%20-471.16%20461.497%20-360.425%20430.554V437.345C-360.425%20448.297%20-357.223%20463.159%20-353.219%20463.159C-349.217%20463.159%20-346.014%20448.69%20-346.014%20437.345V426.534C-327.671%20421.405%20-309.009%20416.196%20-290.323%20410.987C-289.658%20416.297%20-288.322%20420.922%20-286.77%20420.922C-285.031%20420.922%20-283.563%20414.967%20-283.006%20408.941C-265.313%20404.004%20-247.635%20399.067%20-230.221%20394.211C-229.539%20399.349%20-228.234%20403.712%20-226.724%20403.712C-225.03%20403.712%20-223.594%20398.06%20-223.006%20392.196C-171.306%20377.788%20-135.618%20367.827%20-75.1493%20350.986C6.68585%20350.986%2051.7902%20350.986%20143.136%20350.986V1215.95C143.136%201215.95%20146.51%201257.78%20163.301%201279.77H405.236C422.033%201257.78%20425.401%201215.95%20425.401%201215.95V350.986C441.586%20350.986%20578.296%20350.986%20578.296%20350.986H643.689C816.224%20399.039%20979.43%20441.842%201149.47%20492.5C1182.28%20502.273%201191.08%20508.913%201197.48%20516.349C1202.6%20522.284%201214.56%20552.965%201219.89%20567.554V544.098C1219.7%20539.785%201219.58%20535.826%201219.46%20532.128C1218.82%20511.996%201218.41%20499.25%201209.89%20476.469C1199.8%20449.496%201164.57%20422.463%201137.87%20408.448C1124.23%20401.294%20664.368%20168.303%20664.368%20168.303L550.076%20110.41L461.626%2065.6169C461.626%2065.6169%20450.878%2061.1322%20445.101%2053.8887C432.014%2037.4703%20427.619%209.6994%20427.619%200.723938L425.401%20-3.05139V-464.163C425.401%20-464.163%20426.721%20-517.099%20405.246%20-543.941H405.256Z%22%20fill%3D%22%23F5F6F9%22%2F%3E%3C%2Fsvg%3E');
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center center;
    width: 100%;
    margin-top: ${props => props.theme.spacing.spacing12};
    padding: ${props => props.theme.spacing.spacing20} 
             ${props => props.theme.spacing.spacing30} 
             ${props => props.theme.spacing.dialogHorizontalPadding} 
             0;
    
    ${props => props.theme.screenMediaQuery.smallScreen} {
        padding-top: ${props => props.theme.spacing.spacing36};
    }
    
    
`

const BottomSpacerBox = styled.div`
    width: 100%;
    height: calc(45px + 1.5 * ${props => props.theme.spacing.dialogHorizontalPadding});
    background-color: ${props => props.theme.colors.lightTint};
`

const IntroductionBox = styled.div`
    color: ${props => props.theme.colors.darkTint};
    font-size: ${props => props.theme.fontSize.body1};
    
`

const ReasonsContainerBox = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
`

/*
background: linear-gradient(180deg, #FFFFFF 41.13%, rgba(255, 255, 255, 0.873134) 56.32%, rgba(255, 255, 255, 0) 92.39%);
transform: rotate(-180deg);
*/
const UpSellButtonsContainerBox = styled.div`
    position: absolute;
    bottom: 0;
    width: 100%;
    padding: 0 ${props => props.theme.spacing.dialogHorizontalPadding} ${props => props.theme.spacing.dialogHorizontalPadding} ${props => props.theme.spacing.dialogHorizontalPadding};
    z-index: ${HIGHLIGHTED_SEATS_Z_INDEX + 1};
    
    
`

const TitleBox = styled.div`
    padding-top: ${props => props.theme.spacing.spacing8};
`


export const RandomSeatAllocationDialogComponent: React.FC<{dialogHandler: IDialogConfirmationHandler; seatMap: ISegmentSeatMapEditorViewModel}> = observer((props) => {
    const services = useServices();


    return (
        <StandardDialogPageComponent>
            <StandardDialogHeaderComponent dialogHandler={props.dialogHandler}
                                           closeButtonVisibility={"not-render"}
                                           title={<TitleBox>{services.language.translate("If you decide to proceed without a seat:")}</TitleBox>}
                                           />

            <DialogContentRoot dialogHandler={props.dialogHandler} ignoreVerticalPaddingsWhenComputeHeight={true}>
                <DialogContentContainerBox>
                    <IntroductionBox>
                        {services.language.translate('Check-in will open 24 hours before the flight and you will be assigned a random seat. That can be changed for a fee, likely higher than what you would pay now.')}
                    </IntroductionBox>
                    <ReasonsContainerBox>
                        <SeatSelectionReasonComponent title={services.language.translate("You'll likely pay more later")}
                                                      description={services.language.translate("The best seats go fast. Why sit in the middle over near the engine?")}
                                                      icon={<HandWithCashIcon/>}/>

                        <SeatSelectionReasonComponent title={services.language.translate("Sit alone or in the middle")}
                                                      description={services.language.translate("If you're traveling together you are not guaranteed to sit together, why be that person begging to switch before departure?")}
                                                      icon={<ScareFaceIcon/>}/>
                    </ReasonsContainerBox>

                </DialogContentContainerBox>

                <AircraftBodyPartBox>
                    <RandomSeatsGridComponent seatMap={props.seatMap}/>
                </AircraftBodyPartBox>
                <BottomSpacerBox/>
                <UpSellButtonsContainerBox>
                    <UpsellSuggestionComponent acceptButtonLabel={services.language.translate('I will select a seat now')}
                                               rejectButtonLabel={services.language.translate('I prefer a random seat')}
                                               acceptButtonClick={() => props.dialogHandler.accept()}
                                               rejectButtonClick={() => props.dialogHandler.reject()}
                                               renderIcon={() => (<ShootingStarIcon/>)}/>
                </UpSellButtonsContainerBox>

            </DialogContentRoot>
        </StandardDialogPageComponent>
    );
})